import { useLocation, useParams } from 'react-router-dom';

export default function useStoreNo() {
  const params = useParams();
  const location = useLocation();

  const queryStoreNo = location
    ? new URLSearchParams(location.search).get('storeNo')
    : null;

  const paramStoreNo = params?.storeNo;

  if (paramStoreNo) return String(paramStoreNo);
  if (queryStoreNo) return String(queryStoreNo);

  try {
    const persisted = localStorage.getItem('persist:root');
    if (persisted) {
      const root = JSON.parse(persisted);
      const userInfo = root && root.userInfo ? JSON.parse(root.userInfo) : null;
      const storeNo = userInfo?.storeNo;
      if (storeNo) return String(storeNo);
    }
  } catch (_) {}

  try {
    const last = localStorage.getItem('last_storeNo');
    if (last) return String(last);
  } catch (_) {}

  return null;
}
